import { GET_ACCESS_SUCCESS, GET_MY_PROFILE_SUCCESS, SAVE_PROJECT_SESSION } from './auth.types';

const initialState = {
    accessToke: null,
    userInfo: null,
    permissions: '',
    accessList: [],
    therapySession: null,
    therapySessionEvents: {},
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MY_PROFILE_SUCCESS:
            return {
                ...state,
                userInfo: action.payload,
            };

        case GET_ACCESS_SUCCESS:
            return {
                ...state,
                accessList: action.payload,
            };

        case SAVE_PROJECT_SESSION:
            return {
                ...state,
                therapySession: action.payload,
                therapySessionEvents: action.payload?.evenType
                    ? { ...state.therapySessionEvents, [action.payload.evenType]: action.payload }
                    : state.therapySessionEvents,
            };

        default:
            return state;
    }
};
